import React from 'react';
import { PortfolioPosition } from 'portfolio/PortfolioSelection';
import { OpenSubmissionsChartData } from 'widgets/openSubmissions/OpenSubmissionsChartData';
import OpenSubmissionsDoughnutChart from 'widgets/openSubmissions/doughnut/OpenSubmissionsDoughnutChart';

interface OpenSubmissionsDoughnutChartProps {
    allowHideDoughnut?: boolean;
    selectedPosition: PortfolioPosition;
    data: OpenSubmissionsChartData;
}

export default function OpenSubmissionsChart(
    props: OpenSubmissionsDoughnutChartProps
) {
    const { selectedPosition, data } = props;

    return (
        <OpenSubmissionsDoughnutChart
            className="capsule-body"
            selectedPosition={selectedPosition!}
            allowHideDoughnut={false}
            chartData={data}
            doughnutSize={94}
            hideHelp={false}
        />
    );
}
